import React from "react";
import classes from "./Services.module.css";

const Orthotics = () => {
  return (
    <div className={classes.Intro}>
      <h1 className={classes.focusLine}>
        <span>Orthotics</span>
      </h1>
      <div className={classes.container1}>
        <p>
          Our feet are highly complex structures, with each foot consisting of
          26 bones and hundreds of muscles, ligaments, tendons, and blood
          vessels. Your feet support and balance your body weight, and any
          alterations in your foot structure and alignment can have poor
          consequences for other joints in your body and even your overall
          health. Custom orthotics are prescription medical devices which are
          worn inside the shoes to correct foot alignment issues which cause
          biomechanical imbalances during walking, standing, or running. Wearing
          foot orthotics can also help to relieve foot pain caused by medical
          conditions including plantar fasciitis, bursitis, diabetes and
          arthritis.
        </p>
        <h3>6 Important benefits of orthotics</h3>
        <p></p>
        <div className={classes.addtabs}>
          <h4>1. Providing support for your feet</h4>
          <p>
            Custom orthotics are designed to provide support for the anatomical
            arches of your feet to give you more stability while you stand and
            walk. Although over-the-counter shoe inserts can also provide some
            stability for your foot, they were not designed to conform to any
            individual foot, and will not provide optimal balance and support
            over the entire surface of your foot. In contrast, custom orthotics
            will specifically help to correct misalignments in your problem
            areas and provide support all along the surface of your feet. Unlike
            over-the-counter generic insoles, custom orthotics can correct foot
            abnormalities such as pronation (collapsed arches) and supination
            (high arches).
          </p>
          <h4>2. Protecting your joints</h4>
          <p>
            When you walk, run or jump and your feet meet the ground, the actual
            force applied to the joints of your feet, legs and spine is
            equivalent to several times your weight. Over time, the wear and
            tear on the body’s joints can cause pain and soreness, especially
            for individuals who are overweight, often walk on hard surfaces, or
            have foot problems such as flat feet. However, custom orthotics can
            help your feet support the force load of your body, distributing the
            pressure more evenly across the surface of your feet. In addition,
            custom orthotics can absorb impact to help you stay active
            throughout the day. Importantly, custom orthotics are also effective
            when your feet are different from each other, helping to restore
            balance and preventing alignment-related problems.
          </p>
          <h4>3. Reducing pain</h4>
          <p>
            Misalignments in foot structure caused by conditions such as flat
            feet, arthritis and plantar fasciitis can cause significant pain in
            other parts of the body. This happens due to increased strain on the
            ankles, knees and lower back as the body struggles to adjust its
            biomechanical balance to compensate for the poor foot alignment.
            Custom orthotics can help to alleviate pain due to biomechanical
            misalignments, and help to promote healing without causing
            unnecessary strain on other joints and parts of the body.
            Importantly, custom orthotics can protect individuals who have
            diabetes from developing foot ulcers.
          </p>
          <h4>4. Enhancing your athletic performance</h4>
          <p>
            Custom orthotics can also help you improve your athletic
            performance. Wearing orthotics specifically designed for your
            athletic activity can help to reduce the force load of the technical
            demands of a specific sport, helping you produce more efficient and
            precise movements. Moreover, custom orthotics can help to distribute
            your weight more evenly across the surface of the foot, improving
            your balance. Orthotic devices also provide foot protection, but
            absorb shock and create better motion control, improve foot and leg
            movements and even reduce muscle fatigue. For best athletic
            performance, your athletic custom orthotics should be designed for
            your specific physical activity.
          </p>
          <h4>5. Injury prevention</h4>
          <p>
            While walking or running, our feet take a pounding, especially for
            those of us who spend a lot of time on our feet. Fortunately, custom
            orthotics can help to prevent and treat many types of muscle and
            bone problems, including injuries to the tendons, muscles and
            joints, as well as stress fractures. According to scientific
            research, custom orthotics can help to prevent injury such as medial
            tibial stress syndrome, plantar fasciitis, and knee pain. According
            to research findings, foot orthotics reduced the risk of injuries by
            28%, and reduced the risk of stress fractures by 41%. In contrast,
            over-the-counter shock absorbing insoles did not produce similar
            protective effects.
          </p>
          <h4>6. Improving your well-being</h4>
          <p>
            Improving the balance and alignment of your feet can reduce pressure
            from other parts of your body and improve your overall health. For
            instance, if foot, ankle or knee pain is preventing you from being
            more active or sleeping well at night, custom orthotics can have a
            positive effect on your whole health.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Orthotics;
